import * as util from "./util"

/* To locally debug this script via Webflow the best option I've found is to
add two scripts in Webflow:
<script src="http://localhost:3000/????.bundle.js"></script>
<script src="angry-boyd-1669aa.netlify.app/????.bundle.js" crossorigin="anonymous"></script>
The below check ensures that if localhost loads successfully the second
(production) script won't run.
Initially I tried to add the script dynamically in Webflow but that didn't
work - I needed it to run immediately but it wouldn't. */
if (typeof SharesyWebflow === "undefined") {
  util.initSentry()

  window.amplitudeOnLoad = function (instance) {
    util.amplitudeInit(instance, "Booking Page Viewed")
  }

  // Wrap everything with Revealing Module Pattern
  window.SharesyWebflow = (function () {
    var searchParams = util.getSearchParams()

    async function purchase() {
      let stripeSession = searchParams.get("session_id")
      if (stripeSession) {
        if (searchParams.has("success")) {
          document.getElementById("preloader-background").style.display = "none"
          document.getElementsByClassName("basket")[0].style.display = "none"
          util.logAmplitudeEvent(
            "Purchase Not Attempted - Previously Purchased"
          )
        } else {
          try {
            const data = await util.api
              .post("purchase-combined", {
                json: {
                  sessionId: stripeSession,
                },
                retry: { limit: 0 },
              })
              .json()
            if (data.id) {
              util.updateUrlParam("success", 1, false, false)
              document.getElementById("basket-image").src = data.imageUrl
              let basketSpace = document.getElementById("basket-space-name")
              basketSpace.innerText = data.spaceName + ", " + data.venueName
              basketSpace.href = "https://www.sharesy.com/s/" + data.spaceSlug
              document.getElementById("basket-ref").innerText = data.id
              document.getElementById("basket-date").innerText =
                data.friendlyDate
              document.getElementById("basket-time").innerText =
                data.friendlyTimes
              document.getElementById("basket-price-detail").innerText =
                data.basketPriceDetail
              document.getElementById("basket-price-total").innerText =
                data.basketPriceTotal

              let subtotal = parseFloat(data.subtotal)
              if (data.addons && data.addons.length > 0) {
                let basketAddons = document.getElementById("basket-addons")
                for (const addon of data.addons) {
                  subtotal += parseFloat(addon.price)
                  const newAddonDiv = document.createElement("div")
                  basketAddons.insertBefore(newAddonDiv, basketAddons.lastChild)
                  newAddonDiv.classList.add("flex-between")
                  const addonNameDiv = document.createElement("div")
                  newAddonDiv.appendChild(addonNameDiv)
                  addonNameDiv.innerText = addon.name
                  const addonPriceDiv = document.createElement("div")
                  newAddonDiv.appendChild(addonPriceDiv)
                  addonPriceDiv.innerText =
                    "£" + parseFloat(addon.price).toFixed(2)
                }
                document.getElementById("basket-grand-total").innerText =
                  "£" + subtotal.toFixed(2)
                basketAddons.classList.remove("hide")
              }

              if (data.promoCode) {
                document.getElementById("total-paid").innerText = Number(
                  data.stripeTotal
                ).toLocaleString("en-GB", {
                  style: "currency",
                  currency: "GBP",
                })
                document.getElementById("promo-code").innerText = data.promoCode
                document.getElementById("promo-total").innerText = Number(
                  data.stripeTotal - subtotal
                ).toLocaleString("en-GB", {
                  style: "currency",
                  currency: "GBP",
                })
                document
                  .getElementById("promo-section")
                  .classList.remove("hide")
                document
                  .getElementById("total-section")
                  .classList.remove("hide")
              }
              util.logAmplitudeEvent("Purchase Succeeded")
              try {
                let revenue = new amplitude.Revenue()
                  .setProductId(data.appointmentTypeId)
                  .setPrice(data.stripeTotal)
                  .setQuantity(1)
                amplitude.getInstance().logRevenueV2(revenue)
              } catch (err) {}
              try {
                let expected_commission = data.stripeTotal * 0.15
                // Google Ads conversion tracking
                gtag("event", "conversion", {
                  send_to: "AW-344077360/pI4iCIj_pNsCELDoiKQB",
                  value: expected_commission,
                  currency: "GBP",
                  transaction_id: data.id,
                })
                // BingAds conversion tracking
                /*
                window.uetq = window.uetq || []
                window.uetq.push("event", "purchase", {
                  revenue_value: expected_commission,
                  currency: "GBP",
                })*/
              } catch (err) {}
              try {
                if (data.wantsViewing) {
                  document.getElementById("viewing-instructions").innerText =
                    data.venueViewingInstructions
                  if (data.virtualTourUrl) {
                    document.getElementById("virtual-tour-link").href =
                      data.virtualTourUrl
                    document
                      .getElementById("viewing-virtual-tour")
                      .classList.remove("hide")
                  }
                  document
                    .getElementById("viewing-section")
                    .classList.remove("hide")
                }
              } catch (err) {
                util.logToSentry(err)
              }
            } else if (
              data.message &&
              data.message === "Stripe session already purchased"
            ) {
              document.getElementById("purchase-success").style.display = "none"
              document.getElementById("duplicate-message").style.display =
                "flex"
              util.logAmplitudeEvent("Purchase Error - Duplicate")
            } else {
              document.getElementById("purchase-success").style.display = "none"
              document.getElementById("purchase-error").style.display = "flex"
              util.logAmplitudeEvent("Purchase Error - No Data Id")
            }
          } catch (error) {
            document.getElementById("purchase-success").style.display = "none"
            document.getElementById("purchase-error").style.display = "flex"
            util.logAmplitudeEvent("Purchase Error - API Error")
            util.logToSentry("Purchase error for session " + stripeSession)
            util.logToSentry(error)
          }
          document.getElementById("preloader-background").style.display = "none"
        }

        document
          .getElementById("feedback-submit")
          .addEventListener("click", function (e) {
            let feedbackForm = document.getElementById("feedback-form")
            if (feedbackForm.checkValidity()) {
              e.preventDefault()
              let button = document.getElementById("feedback-submit")
              let buttonText = button.value
              window.requestAnimationFrame(() => {
                button.value = "Please wait..."
                button.disabled = true
              })
              util.logAmplitudeEvent("Post Purchase Feedback Submitted", {
                Feedback: document.getElementById("feedback").value,
              })
              document
                .getElementById("feedback-message")
                .classList.remove("hide")
              document
                .getElementById("feedback-form-block")
                .classList.add("hide")
              button.disabled = false
              button.value = buttonText
            } else {
              feedbackForm.reportValidity()
              util.logAmplitudeEvent(
                "Post Purchase Feedback Submitted Without Message"
              )
            }
          })
      } else {
        util.logAmplitudeEvent("Missing Stripe Session ID")
      }
    }

    function init() {
      try {
        purchase()
      } catch (err) {
        util.logToSentry(err)
      }
    }

    return {
      init: init,
    }
  })()
}
